export const Routes = {
  DESIGN: '/design',
  EXPORT: '/export',
  TEMPLATES: '/templates',
  PRIVATE_LINK_VIEW: '/pl',
};

export const GeneratorPaths = {
  Infographic: 'infographic-generator',
  Poster: 'poster-generator',
  Card: 'card-generator',
  Chart: 'chart-generator',
};
